export default {
  harassment: {
    create: {
      ingress:
        'Her har du muligheten til å fortelle oss mer om hva du har vært vitne til eller opplevd i {organizationTitle}. Vi er veldig takknemlig for at du hjelper oss med å holde arbeidsplassen trygg.',
      instructions:
        'Skriv rapporten i tekstfeltet under. Du kan bestemme om du vil inkludere e-postadressen din i rapporten, eller om du vil være anonym. Uansett om du er anonym eller ikke, er det mulig å komme tilbake og følge opp saken etter at du har sendt inn rapporten.',
      instructions1:
        'Du vil motta bekreftelse på at rapporten er sendt, en saks-id og et passord som du kan bruke til å gå tilbake og følge opp saken, uansett om du er anonym eller ikke.',
      instructions2:
        'Rapporten kommer til å bli mottatt av spesielt oppnevnte administrative ledere i {organizationTitle}. Ingen andre kan lese rapporten du har sendt. Hvis du har lagt inn en e-postadresse, vil du bli underrettet når  saken endrer status og om organisasjonen har noen spørsmål til deg. Vi vil da behandle din identitet med konfidensialitet og ikke avsløre den såfremt det ikke er nødvendig for saken.',
      instructionsHeader: 'Hvordan fungerer det?',
      options: {
        confirmNotToIncludeEmail:
          'Jeg forstår at jeg ved å la være å inkludere e-postadressen min frasier meg muligheten til å bli underrettet når saken min endrer status og at mottakerorganisasjonen ikke vet hvem jeg er.',
        includeEmail: 'Jeg ønsker å inkludere e-postadressen min'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Av sikkerhetsgrunner vil du ikke kunne lese eller gjøre endringer i rapporten etter at du har sendt den. Imidlertid kan du gå tilbake senere og følge sakens status, se alle oppfølgingsspørsmål fra {organizationTitle} og selv anonymt fylle ut med ytterligere informasjon.',
        confirmDescriptionEmailIncluded:
          'Siden du har valgt å inkludere e-posten din, vil vi kontakte deg {email} når saken er åpnet og om vi har noen spørsmål til deg. Vennligst sjekk rapporten din før du sender den inn.',
        confirmDescriptionEmailNotIncluded:
          'Du har valgt ikke å inkludere en e-postadresse i rapporten, så vi vil ikke være i stand til å kontakte deg. Sjekk rapporten under før du sender den inn.',
        createDescription: 'Vennligst legg inn beskrivelsen din her:',
        placeholder: 'Jeg vil gjerne rapportere om...',
        reporterGuide: {
          question1: 'Hva går bekymringen ut på?',
          question2: 'Når skjedde dette?',
          question3: 'Hvem var involvert?',
          question4: 'Hvor skjedde det?',
          question5: 'Har du tatt med alle detaljer?',
          question6: 'Du kan legge til et bilde om du ønsker',
          title: 'Veiledning for å skrive en rapport'
        },
        responseDescriptionEmailIncluded:
          'Du vil bli underrettet per e-post når saken er åpnet av en administrativ leder.'
      }
    },
    title: 'Rapport til {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Følg en gyldig lenke for å komme hit.'
    },
    buttons: {
      back: 'Gå tilbake',
      continue: 'Fortsett',
      noOption: 'Nei',
      send: 'Send rapport',
      yesOption: 'Ja'
    },
    confirm: {
      title: {
        reportNotSent: 'Rapporten er IKKE sendt!'
      }
    },
    create: {
      email: {
        help:
          'Hvis du velger å inkludere en e-postadresse i rapporten, kontakter vi deg igjen om statusoppdateringer, eller hvis vi har spørsmål. Det er frivillig å legge igjen en e-postadresse.',
        label: 'E-postadresse:',
        placeholder: 'Skriv inn e-postadressen din her'
      },
      ingress:
        'Her har du muligheten til å rapportere uakseptabel oppførsel som du kjenner til, mistenker, som har skjedd eller vil skje i {organizationTitle}. Kanalen skal bare brukes til å rapportere uakseptabel oppførsel i jobbrelaterte situasjoner, og bare hvis du har grunn til å mistenke at informasjonen du har er riktig.',
      instructions:
        'Først velger du hvordan du vil formidle rapporten. Du kan også velge om du vil legge til en e-postadresse i rapporten, eller om du vil være anonym. Enten du er anonym eller ikke, er det mulig å komme tilbake og følge opp saken etter at du har levert rapporten.',
      instructions1:
        'Da får du en bekreftelse på at rapporten er sendt, et saksnummer og et passord du kan bruke, enten du er anonym eller ikke, for å komme tilbake og følge opp saken. Selv om du velger å rapportere på et fysisk møte eller via telefon, kan du også følge opp saken digitalt hvis du vil det.',
      instructions2:
        'Rapporter mottas av utnevnte administratorer i {organizationTitle}. Ingen andre kan lese rapporten du har sendt. Hvis du oppga en e-postadresse, blir du varslet når saken endrer status og hvis organisasjonen har flere spørsmål til deg. Vi behandler din identitet konfidensielt og avslører den ikke, med mindre det er nødvendig for sakens skyld.',
      instructionsHeader: 'Hvordan fungerer det?',
      options: {
        confirmNotToIncludeEmail:
          'Jeg forstår at ved å ikke inkludere e-postadressen, avstår jeg fra muligheten til å bli informert når sakens status endres, fordi den mottakerorganisasjonen ikke vet hvem jeg er.',
        includeEmail: 'Jeg vil inkludere e-postadressen min'
      }
    },
    followup: {
      buttons: {
        submit: 'Hent saken'
      },
      messages: {
        buttons: {
          send: {
            help:
              'Du kan sende en oppfølgingsmelding som blir lest av representanter i den mottakerorganisasjonen. Ingen andre kan lese meldingen.',
            title: 'Send melding'
          }
        },
        messageSent: 'Takk for meldingen din!',
        placeholder: 'Skriv en melding her',
        reporter: 'Varsler',
        title: 'Meldinger',
        writtenByAdmin: 'Administrator'
      },
      status: {
        new: {
          description: 'Rapporten er mottatt og blir snart behandlet.',
          title: 'Ny'
        },
        open: {
          description:
            'Rapporten er mottatt og er under behandling. Vennligst sjekk på nytt senere for å få oppdateringer. Hvis du har oppgitt kontaktinformasjon, tar vi kontakt med deg.',
          title: 'Åpen'
        },
        solved: {
          description:
            'Rapporten er behandlet og granskningen er nå fullført. Hvis du har oppgitt kontaktinformasjon, kontakter vi deg med videre detaljer.',
          title: 'Løst'
        }
      },
      statusLabel: 'Saken har status:',
      title: 'Sak {caseName}'
    },
    followupLogin: {
      caseLabel: 'Saksnummer:',
      passwordLabel: 'Passord:',
      title: 'Følg opp saken'
    },
    messages: {
      error: {
        failedToSendReport: 'Kunne ikke sende rapporten',
        organizationNotFound:
          'Vi fant ingen organisasjon å sende rapporten din til. Sørg for at du har fulgt en gyldig lenke for å komme hit.',
        whistleblowerInfoNotFound:
          'Fant ingen informasjon om en varsler som har rapportert fra denne organisasjonen'
      }
    },
    received: {
      bottomWarning:
        'Merk! Dette er den eneste sjansen du har til å se informasjonen over, så ta vare på den nå!',
      caseLabel: 'Saksnummer:',
      linkLabel: 'Lenke',
      passwordLabel: 'Passord:',
      title: 'Rapporten mottatt!',
      topWarning: 'Lagre informasjonen nedenfor på en sikker måte!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Når du har sendt inn rapporten, kan du av sikkerhetshensyn ikke lenger lese den eller gjøre endringer. Du kan imidlertid komme tilbake senere og sjekke status på saken, se eventuelle oppfølgingsspørsmål fra {organizationTitle}, og på anonymt grunnlag kan du også legge inn mer informasjon,.',
        confirmDescriptionEmailIncluded:
          'Siden du har valgt å inkludere e-postadressen din, kontakter vi {email} når saken er åpnet og hvis vi har spørsmål til deg. Sjekk rapporten nedenfor før du sender den inn.',
        confirmDescriptionEmailNotIncluded:
          'Du har valgt å ikke inkludere en e-postadresse sammen med rapporten, så vi kan ikke kontakte deg. Sjekk rapporten nedenfor før du sender den inn.',
        createDescription:
          'Beskriv hva som skjedde og hvorfor du vil rapportere dette. Ikke inkluder personopplysninger med mindre de er relevante for saken.',
        label: 'Jeg vil rapportere digitalt via dette skjemaet',
        placeholder: 'Jeg vil rapportere …',
        reporterGuide: {
          question1: 'Hva gjelder det?',
          question2: 'Når skjedde dette?',
          question3: 'Hvem var involvert?',
          question4: 'Hvor skjedde det?',
          question5: 'Har du tatt med alle detaljene?',
          question6: 'Hvis du vil, kan du legge til et bilde',
          title: 'Veiledning til å skrive rapport'
        },
        responseDescriptionEmailIncluded:
          'Du får et e-postvarsel når saken er åpnet av en av administratorene. Dette skjer i løpet av syv dager. Når saken er åpnet, fullfører vi granskningen innen tre måneder.',
        responseDescriptionEmailNotIncluded:
          'Siden du har valgt å rapportere anonymt, har du avslått å motta et e-postvarsel når saken er åpnet. Du vil heller ikke bli varslet om annen aktivitet i saken. Ved hjelp av detaljene nedenfor kan du likevel gå tilbake og følge status på saken.',
        responseIngress:
          'Takk for rapporten! Vi behandler saken din så snart som mulig.'
      },
      phoneCall: {
        confirmDescription:
          'I neste trinn får du et telefonnummer du kan ringe. Er du sikker på at du vil fortsette med rapporten per telefon?',
        createDescription:
          'Du får muligheten til å levere rapporten som en talemelding.',
        label: 'Jeg vil levere rapporten via telefonanrop',
        message:
          '===Varsleren vil ringe og levere rapporten som talemelding. ===',
        responseDescription:
          'For å levere rapporten ringer du følgende telefonnummer og legger igjen en talemelding:',
        responseInstructions1: 'Ring telefonnummeret ovenfor',
        responseInstructions2: 'Oppgi så mange detaljer som mulig i rapporten',
        responseInstructions3:
          'Hvis du vil bli varslet om endringer i sakens status eller om ny korrespondanse, må du oppgi en e-postadresse eller  et telefonnummer i rapporten.',
        responseInstructions4:
          'Lagre informasjonen nedenfor, slik at du kan gå tilbake og følge opp her.',
        responseInstructionsHeader: 'Instruksjoner',
        responseTitle: 'Rapporter per telefon',
        responseWarning:
          'Hvis du ikke har lagt igjen en talemelding innen syv dager, blir saken automatisk lukket.'
      },
      physicalMeeting: {
        confirmDescription:
          'Vi kontakter deg per {e-post} angående forespørselen din om å rapportere på et fysisk møte. Vil du fortsette?',
        createDescription:
          'Vi tilbyr deg muligheten til å overlevere rapporten på et fysisk møte. For å gjøre det må du oppgi en e-postadresse som vi kan kontakte deg på for å planlegge et møte.',
        label: 'Jeg vil levere rapporten på et fysisk møte',
        message:
          '===Varsleren har bedt om et fysisk møte for å levere rapporten. ===',
        responseDescription:
          'Takk skal du ha! Vi kontakter deg igjen med et forslag om når vi kan møte deg fysisk slik at du levere rapporten.  Sørg for å ta vare på følgende informasjon. Du trenger den hvis du vil følge opp saken din etter møtet.',
        responseTitle: 'Forespørsel om møte er sendt'
      }
    },
    title: 'Rapporter uakseptabel oppførsel i {organizationTitle}'
  }
}
